import { AccessTokenValidatorClient, GraphClient, PhishedClient } from '@data';
import { Container } from './container';

export const initAccessTokenValidatorContainer = () => {
  Container.registerAccessTokenValidatorValidator(AccessTokenValidatorClient.api);
};

// some clients we have require the access tokens which we will get
// after authentication. That's why we init this part of container later
export const initGraphContainer = (graphToken: string) => {
  Container.registerGraphClient(new GraphClient(graphToken).api);
};
export const initPhishedContainer = (idToken?: string) => {
  const client = new PhishedClient(idToken);
  Container.registerPhishedClient(client.api);
  Container.registerZimClient(client.zimApi);
  Container.registerZimHealthClient(client.zimHealthApi);
};
